/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PatchRepoRequest = {
  /**
   * The organization URL slug.
   */
  org: string;
  /**
   * The repository name (URL label).
   */
  name: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  patchRepoRequest: components.PatchRepoRequest;
};

/** @internal */
export const PatchRepoRequest$inboundSchema: z.ZodType<
  PatchRepoRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  org: z.string(),
  name: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
  PatchRepoRequest: components.PatchRepoRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "PatchRepoRequest": "patchRepoRequest",
  });
});
/** @internal */
export type PatchRepoRequest$Outbound = {
  org: string;
  name: string;
  "X-On-Behalf-Of"?: string | undefined;
  PatchRepoRequest: components.PatchRepoRequest$Outbound;
};

/** @internal */
export const PatchRepoRequest$outboundSchema: z.ZodType<
  PatchRepoRequest$Outbound,
  z.ZodTypeDef,
  PatchRepoRequest
> = z.object({
  org: z.string(),
  name: z.string(),
  xOnBehalfOf: z.string().optional(),
  patchRepoRequest: components.PatchRepoRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    patchRepoRequest: "PatchRepoRequest",
  });
});

export function patchRepoRequestToJSON(
  patchRepoRequest: PatchRepoRequest,
): string {
  return JSON.stringify(
    PatchRepoRequest$outboundSchema.parse(patchRepoRequest),
  );
}
export function patchRepoRequestFromJSON(
  jsonString: string,
): SafeParseResult<PatchRepoRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PatchRepoRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PatchRepoRequest' from JSON`,
  );
}
